import { path } from '../config/env'

const urls = {                
    goodslist: `${path}/apiv2/goodslist`,
    userSubscriptList: `${path}/apiv2/userSubscriptList`,
    subscript: `${path}/apiv2/subscript`,
    delSubscript: `${path}/apiv2/delSubscript`,
    userInfo: `${path}/apiv2/userInfo`,
    wechatLogin: `${path}/apiv2/wechatLogin`,
    wxpay: `${path}/apiv2/wxpay`,
    paylist: `${path}/apiv2/paylist`,
    wxConfig: `${path}/apiv2/wxConfig`,
    toVip: `${path}/apiv2/toVip`,
}

export default urls



// WEBPACK FOOTER //
// ./src/api/apiUrls.js